import { render, staticRenderFns } from "./PackageManagementForm.vue?vue&type=template&id=6027cb8c&scoped=true"
import script from "./PackageManagementForm.vue?vue&type=script&lang=js"
export * from "./PackageManagementForm.vue?vue&type=script&lang=js"
import style0 from "./PackageManagementForm.vue?vue&type=style&index=0&id=6027cb8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027cb8c",
  null
  
)

export default component.exports